import React from 'react'
import MaterialSymbol from 'components/material-symbol/material-symbol'

const MessagingEmojiPickerIcon = () => (
  <MaterialSymbol
    name="sentiment_satisfied"
    htmlColor="rgba(0, 0, 0, 0.87)"
    fontSize={24}
  />
)

export default MessagingEmojiPickerIcon
